import plugin_vue3_A0OWXRrUgq from "/opt/build/repo/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/opt/build/repo/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "/opt/build/repo/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import plugin_client_mik7N71GmK from "/opt/build/repo/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.mjs";
import templates_plugin_7e4f6da8_cLvyS16cBv from "/opt/build/repo/.nuxt/templates.plugin.7e4f6da8.ejs";
import plugin_client_mLgZJrmjnn from "/opt/build/repo/node_modules/nuxt-vuefire/dist/runtime/auth/plugin.client.mjs";
import unocss_MzCDxu9LMj from "/opt/build/repo/.nuxt/unocss.mjs";
import plugin_client_i8AMfKeYnY from "/opt/build/repo/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import plugin_OrkQhMqHci from "/opt/build/repo/node_modules/@nuxt/image-edge/dist/runtime/plugin.mjs";
import ssr_plugin_B4ptqVdIfe from "/opt/build/repo/node_modules/@vueuse/nuxt/ssr-plugin.mjs";
import scrollToTop_qK8NwO4Kxq from "/opt/build/repo/src/plugins/scrollToTop.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  plugin_client_mik7N71GmK,
  templates_plugin_7e4f6da8_cLvyS16cBv,
  plugin_client_mLgZJrmjnn,
  unocss_MzCDxu9LMj,
  plugin_client_i8AMfKeYnY,
  plugin_OrkQhMqHci,
  ssr_plugin_B4ptqVdIfe,
  scrollToTop_qK8NwO4Kxq
]